import Repository from "./Repository";
import { MakeOffice, Office, OfficeRoom } from "./types/Offices";
const resource = "/offices";

export default {
  get() {
    return Repository.get<Array<Office>>(`${resource}`);
  },
  createOffice(office: MakeOffice) {
    return Repository.post<Office>(`${resource}`, office);
  },
  getOffice(officeId: string) {
    return Repository.get<Office>(`${resource}/${officeId}`);
  },
  updateOffice(officeId: string, office: Partial<MakeOffice>) {
    return Repository.patch<Office>(`${resource}/${officeId}`, office);
  },
  createOfficeRoom(officeId: string, room: OfficeRoom) {
    return Repository.post<OfficeRoom>(`${resource}/${officeId}/rooms`, room);
  },
  getOfficeRoom(roomId: string) {
    return Repository.get<OfficeRoom>(`${resource}/room/${roomId}`);
  },
  deleteOfficeRoom(roomId: string) {
    return Repository.delete<OfficeRoom>(`${resource}/room/${roomId}`);
  },
  updateOfficeRoom(officeId: string, roomId: string, room: OfficeRoom) {
    return Repository.patch<OfficeRoom>(
      `${resource}/${officeId}/rooms/${roomId}`,
      room
    );
  },
  updateTeamMembers(officeId: string, members: { members: Array<string> }) {
    return Repository.post<Office>(`${resource}/${officeId}/members`, members);
  },
};
